import {
  PTAccordion,
  PTAutoComplete,
  PTBadge,
  PTButton,
  PTButtonGroup,
  PTCard,
  PTCarousel,
  PTCheckbox,
  PTChip,
  PTDataTable,
  PTDialog,
  PTDivider,
  PTDropdown,
  PTFileUpload,
  PTInputMask,
  PTInputSwitch,
  PTInputText,
  PTInputTextArea,
  PTMenu,
  PTMessage,
  PTOverlayPanel,
  PTPanel,
  PTPassword,
  PTProgressSpinner,
  PTSidebar,
  PTSkeleton,
  PTTabView,
  PTTimeline,
  PTTooltip,
} from './PTComponents';
import { PrimeReactPTOptions } from 'primereact/api';

const PassThroughOptions: PrimeReactPTOptions = {
  accordion: PTAccordion,
  autocomplete: PTAutoComplete,
  badge: PTBadge,
  button: PTButton,
  // @ts-expect-error type issues.
  buttongroup: PTButtonGroup,
  card: PTCard,
  carousel: PTCarousel,
  checkbox: PTCheckbox,
  chip: PTChip,
  datatable: PTDataTable,
  dialog: PTDialog,
  divider: PTDivider,
  dropdown: PTDropdown,
  fileupload: PTFileUpload,
  inputswitch: PTInputSwitch,
  inputtext: PTInputText,
  inputmask: PTInputMask,
  inputtextarea: PTInputTextArea,
  menu: PTMenu,
  message: PTMessage,
  overlaypanel: PTOverlayPanel,
  panel: PTPanel,
  password: PTPassword,
  progressspinner: PTProgressSpinner,
  sidebar: PTSidebar,
  skeleton: PTSkeleton,
  tabview: PTTabView,
  timeline: PTTimeline,
  tooltip: PTTooltip,
};

export { PassThroughOptions };
